import { render, staticRenderFns } from "./Betflix.vue?vue&type=template&id=3f57ee22&scoped=true&"
import script from "./Betflix.vue?vue&type=script&lang=js&"
export * from "./Betflix.vue?vue&type=script&lang=js&"
import style0 from "./Betflix.vue?vue&type=style&index=0&id=3f57ee22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57ee22",
  null
  
)

export default component.exports